import { Button } from "@/components/ui/button";
import { Zap } from "lucide-react";

const WEB_APP_URL = "https://teacherutilitytoolkit.in/";

export default function TryOnlineButton({ variant = "default", className = "" }) {
  const trackClick = () => {
    if (window.gtag) {
      window.gtag('event', 'click', { event_category: 'try_online', event_label: 'try_online_btn' });
    }
  };

  if (variant === "small") {
    return (
      <Button
        data-testid="try-online-btn"
        asChild
        className={`h-10 px-5 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white rounded-full text-sm font-bold shadow-lg shadow-orange-500/25 ${className}`}
      >
        <a href={WEB_APP_URL} target="_blank" rel="noopener noreferrer" onClick={trackClick}>
          <Zap className="mr-1.5 w-3.5 h-3.5" />
          ବିନା Download ଏଠାରେ ଚଲାନ୍ତୁ
        </a>
      </Button>
    );
  }

  if (variant === "dark") {
    return (
      <Button
        data-testid="try-online-btn"
        asChild
        className={`w-full sm:w-auto h-12 px-8 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white rounded-full text-base font-bold shadow-xl shadow-orange-500/30 ${className}`}
      >
        <a href={WEB_APP_URL} target="_blank" rel="noopener noreferrer" onClick={trackClick}>
          <Zap className="mr-2 w-5 h-5" />
          Download ନ କରି ଏଠାରେ FREE ରେ ଚଲାନ୍ତୁ!
        </a>
      </Button>
    );
  }

  return (
    <Button
      data-testid="try-online-btn"
      asChild
      className={`w-full sm:w-auto h-12 px-8 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white rounded-full text-base font-bold shadow-xl shadow-orange-500/30 ${className}`}
    >
      <a href={WEB_APP_URL} target="_blank" rel="noopener noreferrer" onClick={trackClick}>
        <Zap className="mr-2 w-5 h-5" />
        Download ନ କରି ଏଠାରେ FREE ରେ ଚଲାନ୍ତୁ!
      </a>
    </Button>
  );
}
